import React from "react";

// Components
import { IonImg } from "@ionic/react";

const ImageAthleteProfile = ({ user }: any) => {
  return <IonImg className={"image--profile image--circled"} src={user.member?.profile_image || "assets/profile_image1.png"} />;
};

export default ImageAthleteProfile;
